$(function() {
	$(document).on('focus', 'input[type=text]', function() {
		MOD.WfEasyXdm.sendMessage({INPUTFOCUS: ''});
	});

	$(document).on('blur', 'input[type=text]', function() {
		MOD.WfEasyXdm.sendMessage({INPUTBLUR: ''});
	});
});
